import React from 'react';

import BooksOfAccountsModule from './books-of-accounts.module';
import BooksOfAccounts from 'enums/books-of-accounts';

const BooksOfAccountsCashDisbursementModule = () => {
  return (
    <div>
      <BooksOfAccountsModule type={BooksOfAccounts.CashDisbursement} />
    </div>
  );
};

export default BooksOfAccountsCashDisbursementModule;
